import * as yup from "yup";
import { v4 } from "uuid";

function addRequiredFields(t, required_fields) {
  var output = {};
  if (required_fields.includes("place_of_birth")) {
    output.place_of_birth = yup.string().default("").required(t("isRequired"));
  }
  if (required_fields.includes("passport_number")) {
    output.passport_number = yup.string().default("").required(t("isRequired"));
  }
  if (required_fields.includes("passport_place_of_issue")) {
    output.passport_place_of_issue = yup
      .string()
      .default("")
      .required(t("isRequired"));
  }
  if (required_fields.includes("passport_start_date")) {
    output.passport_start_date = yup
      .date()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .default("");
  }
  if (required_fields.includes("passport_expiry_date")) {
    output.passport_expiry_date = yup
      .date()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .default("");
  }
  if (required_fields.includes("city_code")) {
    output.city_code = yup.string().default("").required(t("isRequired"));
  }
  return output;
}

export function adultGuestSchema(t, required_fields) {
  var output = {
    is_leader: yup.boolean().default(false).required(t("isRequired")),
    title: yup
      .string()
      .oneOf(["MR", "MRS", "MS", "MISS", "DR"], t("isRequired"))
      .required(t("isRequired"))
      .default(""),
    first_name: yup
      .string()
      .required(t("isRequired"))
      .matches(/^[a-zA-Z ]+$/, t("latinCharactersAndSpacesOnly"))
      .default(""),
    last_name: yup
      .string()
      .required(t("isRequired"))
      .matches(/^[a-zA-Z ]+$/, t("latinCharactersAndSpacesOnly"))
      .default(""),
    email: yup
      .string()
      .email(t("validEmail"))
      .when("is_leader", {
        is: true,
        then: (schema) => schema.required(t("isRequired")),
      })
      .default(""),
    // guest_type: yup
    //   .string()
    //   .oneOf(["ADT", "CHD","SNR"])
    //   .default("ADT")
    //   .required(t("isRequired")),
    telephone: yup
      .string()
      .when("is_leader", {
        is: true,
        then: (schema) => schema.required(t("isRequired")),
      })
      .default(""),
    birthday: yup
      .date()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .default(""),
    nationality: yup.string().length(2).required(t("isRequired")).default(null),
    guest_uid: yup.string().default(v4()).required(t("isRequired")),
  };

  return yup.object({ ...output, ...addRequiredFields(t, required_fields) });
}

export function childGuestSchema(t, required_fields) {
  var output = {
    is_leader: yup.boolean().default(false),
    first_name: yup
      .string()
      .required(t("isRequired"))
      .matches(/^[a-zA-Z ]+$/, t("latinCharactersAndSpacesOnly"))
      .default(""),
    last_name: yup
      .string()
      .required(t("isRequired"))
      .matches(/^[a-zA-Z ]+$/, t("latinCharactersAndSpacesOnly"))
      .default(""),
    guest_type: yup
      .string()
      .oneOf(["ADT", "CHD", "SNR"])
      .default("CHD")
      .required(t("isRequired")),
    birthday: yup
      .date()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .default(""),
    nationality: yup.string().length(2).required(t("isRequired")).default(null),
    guest_uid: yup.string().default(v4()).required(t("isRequired")),
    title: yup
      .string()
      .oneOf(["MR", "MRS", "MS", "MISS", "DR"])
      .nullable(true)
      .default(null),
    telephone: yup.string().default(""),
    email: yup.string().email().default(""),
  };
  return yup.object({ ...output, ...addRequiredFields(t, required_fields) });
}

export function seniorGuestSchema(t, required_fields) {
  var output = {
    is_leader: yup.boolean().default(false).required(t("isRequired")),
    title: yup
      .string()
      .oneOf(["MR", "MRS", "MS", "MISS", "DR"], t("isRequired"))
      .required(t("isRequired"))
      .default(""),
    first_name: yup
      .string()
      .required(t("isRequired"))
      .matches(/^[a-zA-Z ]+$/, t("latinCharactersAndSpacesOnly"))
      .default(""),
    last_name: yup
      .string()
      .required(t("isRequired"))
      .matches(/^[a-zA-Z ]+$/, t("latinCharactersAndSpacesOnly"))
      .default(""),
    email: yup
      .string()
      .email(t("validEmail"))
      .when("is_leader", {
        is: true,
        then: (schema) => schema.required(t("isRequired")),
      })
      .default(""),
    guest_type: yup
      .string()
      .oneOf(["ADT", "CHD", "SNR"])
      .default("SNR")
      .required(t("isRequired")),
    telephone: yup
      .string()
      .when("is_leader", {
        is: true,
        then: (schema) => schema.required(t("isRequired")),
      })
      .default(""),
    birthday: yup
      .date()
      .typeError(t("isRequired"))
      .required(t("isRequired"))
      .default(""),
    nationality: yup.string().length(2).required(t("isRequired")).default(null),
    guest_uid: yup.string().default(v4()).required(t("isRequired")),
  };
  return yup.object({ ...output, ...addRequiredFields(t, required_fields) });
}

export function validationSchema({ t, adults, seniors, required_fields }) {
  return yup.object({
    adults: yup
      .array()
      .of(adultGuestSchema(t, required_fields))
      .min(seniors === 0 && adults > 0 ? 1 : 0, t("atLeastOneAdult")),
    children: yup.array().of(childGuestSchema(t, required_fields)).min(0),
    seniors: yup
      .array()
      .of(seniorGuestSchema(t, required_fields))
      .min(adults === 0 && seniors > 0 ? 1 : 0, t("atLeastOneSenior")),
  });
}
